import { AppConfig } from '../../api/whitelabel/whitelabel.types';

export const selectAppConfig = (state: WebOrder.State): AppConfig =>
  state.flipdish.AppConfig &&
  state.flipdish.AppConfig.status === 'success' &&
  state.flipdish.AppConfig.data;
